import { MoreOutlined } from "@ant-design/icons";
import { influencerActionsEnum } from "@entities/brief/lib/constants";
import { InfluencerCommercial } from "@features/InfluencerCommercialsV2/InfluencerCommercialsCost/InfluencerCommercial";
import { IBriefCampaignBriefInfluencer } from "@shared/lib/types/briefCampains";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { Button, Dropdown, Menu, Modal, Popover } from "@shared/ui";
import { useState } from "react";
import { AskInfluencerCommercials } from "../askInfluencerCommercials/AskInfluencerCommercials";
import { NegotiateInfluencerCommercialsPopover } from "../negotiateInfluencerCommercials/NegotiateInfluencerCommercialsPopover";
import styles from "./styles.module.scss";

interface Props {
  briefInfluencer: IBriefInfluencerV2 | IBriefCampaignBriefInfluencer;
  actions: influencerActionsEnum[];
}

type CommercialPopoverType = "add" | "add-new" | "view" | null;

export default function InflunencerCommercialsDropDown({
  briefInfluencer,
  actions,
}: Props) {
  const [commercialPopover, setCommercialPopover] =
    useState<CommercialPopoverType>(null);
  const [isCommercialsRequestedModal, setIsCommercialsRequestedModal] =
    useState(false);
  const [isNegotiatePopoverOpen, setIsNegotiatePopoverOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMenuClick = ({ key }: { key: string }) => {
    if (key === influencerActionsEnum.addInfluencerCommercial) {
      setIsDropdownOpen(false);
      setCommercialPopover("add");
    } else if (key === influencerActionsEnum.addNewInfluencerCommercial) {
      setIsDropdownOpen(false);
      setCommercialPopover("add-new");
    } else if (key === influencerActionsEnum.viewInfluencerCommercial) {
      setIsDropdownOpen(false);
      setCommercialPopover("view");
    } else if (key === influencerActionsEnum.negotiate) {
      setIsDropdownOpen(false);
      setIsNegotiatePopoverOpen(true);
    } else if (key === influencerActionsEnum.resend) {
      setIsCommercialsRequestedModal(true);
    }
  };

  const handleCloseCommercialPopover = () => {
    setCommercialPopover(null);
  };

  const getModalType = () => {
    switch (commercialPopover) {
      case "add":
        return "create" as const;
      case "add-new":
        return "create-new" as const;
      case "view":
        return "view" as const;
      default:
        return "create" as const;
    }
  };

  const getPopoverTitle = () => {
    switch (commercialPopover) {
      case "add":
        return "Add Influencer Commercial";
      case "add-new":
        return "Add  Commercial";
      case "view":
        return "View Influencer Commercial";
      default:
        return "";
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {actions
        .filter((action) => action !== influencerActionsEnum.resend)
        .map((action) => (
          <Menu.Item key={action}>{action}</Menu.Item>
        ))}
    </Menu>
  );

  return (
    <>
      <NegotiateInfluencerCommercialsPopover
        briefInfluencer={briefInfluencer}
        open={isNegotiatePopoverOpen}
        onOpenChange={setIsNegotiatePopoverOpen}
      >
        <Popover
          open={commercialPopover !== null}
          className={styles.popover}
          trigger={["click"]}
          placement="right"
          title={getPopoverTitle()}
          content={
            commercialPopover !== null ? (
              <InfluencerCommercial
                onClose={handleCloseCommercialPopover}
                briefInfluencer={briefInfluencer}
                type={getModalType()}
              />
            ) : null
          }
          onOpenChange={(open) => {
            if (!open) {
              handleCloseCommercialPopover();
            }
          }}
          destroyTooltipOnHide
        >
          <Dropdown
            overlay={menu}
            open={isDropdownOpen}
            onOpenChange={setIsDropdownOpen}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Button icon={<MoreOutlined />} type="text" />
          </Dropdown>
        </Popover>
      </NegotiateInfluencerCommercialsPopover>

      <Modal
        open={isCommercialsRequestedModal}
        onCancel={() => setIsCommercialsRequestedModal(false)}
        // onClose={() => setIsCommercialsRequestedModal(false)}
        footer={null}
        title="Ask Commercial"
        destroyOnClose
        width={1100}
      >
        <AskInfluencerCommercials
          briefInfluencer={briefInfluencer}
          onClose={() => setIsCommercialsRequestedModal(false)}
        />
      </Modal>
    </>
  );
}
